var render, staticRenderFns
import script from "./screen-table.vue?vue&type=script&lang=js"
export * from "./screen-table.vue?vue&type=script&lang=js"
import style0 from "./screen-table.vue?vue&type=style&index=0&id=1e03394c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e03394c",
  null
  
)

export default component.exports